<div mat-dialog-content id="paymentDialog">
    <div class="button" *ngIf="!showNewPayment">
        <mat-icon style="margin-right: 10px;" (click)="Close()" style='font-size: 18px;margin: 3px;'>cancel</mat-icon>
    </div>
    <iframe *ngIf="!showNewPayment" [src]="url" width="600px" height="600px" ></iframe>
    <div *ngIf="showNewPayment">
        <div class="card-payment-dialog-content">
            <div>
                <div class="col-sm-12 no-padding">
                    <div class="modal-header">
                        <button type="button" class="close" (click)="Close()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="col-sm-12  modal-body no-pad">
                        <div class="payment-detail" style="padding:3px 20px;">
                            <label class="total">Total Amount :<span class="pl-3" id="total"></span></label>
                            <label class="fee">Service Fees :<span class="pl-3" id="serviceFee"> </span></label>
                            <span class="" id="serviceFeeMessage"> </span>
                            <label class="amount">Payable Amount :<span class="pl-3" id="payableAmount">
                                </span></label>
                        </div>
                        <div class="cards_contaienr mt-2">
                            <div class="cards_progress-container">
                                <div class="cards_progress" id="cards_progress"></div>
                                <div class="cards_circle step_1 active">1</div>
                                <div class="cards_circle step_2 ">2</div>
                            </div>
                            <div class="d-flex" style="justify-content:space-between;margin-bottom: 10px;">
                                <div class="steper_color">Card Details</div>
                                <div class="steper_color">Cardholder Info</div>
                            </div>
                            <!-- <button class="cards_btn" id="prev" disabled>Prev</button>
                            <button class="cards_btn" id="next">Next</button> -->
                        </div>
                        <div class="cardtypesbox">
                            <form name="tokenform" id="tokenform">
                                <iframe [src]="url" name="tokenFrame" width="100%" height="265px" src="" style="border: none;"></iframe>
                            </form>
                        </div> 
                        <div class="cardtypesdetailbox hide" >
                            <div class="row carderperson" style="padding:50px;;">
                                <label class="name">Cardholder Name <span class="red-font">*</span>
                                    <input #nameInput id="nameInput" type="text" name="name" maxlength="40" autocomplete="off"
                                        placeholder="John Doe" title="Cardholder Name" aria-label="Cardholder Name"
                                        class="nametext capital" (keyup)="enableButtonOnEnter()">
                                </label>
                                <label class="bill">Zip Code <span class="red-font">*</span>
                                    <input #postalInput id="postalInput" type="text" name="postal" maxlength="5" autocomplete="off"
                                        pattern="[0-9]{5}" placeholder="30022" title="Zip Code" aria-label="Zip Code"
                                        class="pintext" (keyup)="enableButtonOnEnter()"></label>
    
                            </div>
                        </div>
                        <div *ngIf="showCaptchaForCard && isRequestDeposit">
                            <re-captcha #captchaRef  siteKey="6LdMENsZAAAAAMqFM9PKysYwkmEO778o2j_iS9Qh" (resolved)="onCardCaptchaResolved($event)">
                            </re-captcha>
                            <p *ngIf="cardCaptchaError" style="color: red;">{{ cardCaptchaError }}</p>
                        </div>
                    </div>
                    <div class="modal-footer"
                        style="justify-content: space-between;padding: 0px;padding-top: 20px; margin: 0px -15px">
                        <span style="width: 100%;padding: 10px !important;" class="footerspan text-right">
                            <button type="submit" class="btn btn-secondary" (click)="validateInput()" *ngIf="showNext">Next</button>
                            <button type="submit" class="btn btn-default" (click)="goBack()" *ngIf="showPrev">Prev</button>
                            <button type="submit" class="btn btn-primary" (click)="validateToken()" [disabled]="!isSaveEnabled" *ngIf="showSave && !isRequestDeposit" >Save</button>
                            <button type="submit" class="btn btn-primary" (click)="validateToken()" [disabled]="!isSaveEnabled" *ngIf="showSave && isRequestDeposit" >Pay</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div style="display:flex;justify-content:end;" *ngIf="!showNewPayment">
    <button mat-raised-button (click)="Close()"
        style="background-color: red; color: white;margin-right: 10px;">Close</button>
</div>

<div *ngIf="isPageLoader" class="page-content-loader">
    <div class="content-loader">Loading...</div>
</div>
